import AppManager from '../app-manager'
import Filters from '@nematis/hooks/lib/filters'

export default class PetiteVueAppManager extends AppManager {
  static getType() {
    return 'petiteVue'
  }

  static getConfig() {
    return {
      attrNames: {
        name: 'data-v-app-name',
        id: 'id',
        targetName: 'data-v-target-app-name',
        targetId: 'data-v-target-id'
      }
    }
  }

  static registerHooks() {
    Filters.addAction('customElements.domMutation.loaded', (el) => {
      const targetAppName = this.getAppAttribute(el, 'targetName')
      const targetId = this.getAppAttribute(el, 'targetId')
      const appInfo = this.getAppInfo(targetAppName, targetId)
      if (appInfo) {
        appInfo.app.mount(el)
      }
    }, `app/${this.getType()}/mount`)
  }

  static async _buildApp(appName, id, el, data, filters) {
    const cdn = 'https://cdn.skypack.dev/pin/petite-vue@v0.4.1-gUNZeQmX6vapZ8kp0php/mode=imports,min/optimized/petite-vue.js'
    const {
      createApp, reactive
    } = await import(/* webpackIgnore: true */ cdn)

    const app = createApp({
      $delimiters: ['${', '}'],
      [appName]: reactive(data)
    })

    const directives = filters.applyFilters(`app.${this.getType()}.directives`, {}, appName, id, el)
    for (const name of Object.keys(directives)) {
      app.directive(name, directives[name])
    }

    return app.mount(el)
  }
}
